<template>
  <!--
          作者：gmshop
          时间：2019-10-25
          描述：门店-订单核销记录
      -->
  <div class="user">

    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="">
          <el-input v-model="formInline.order_no" placeholder="请输入订单号"></el-input>
        </el-form-item>
        <el-form-item label="">
          <el-input v-model="formInline.user_id" placeholder="请输入会员id"></el-input>
        </el-form-item>
        
        <el-form-item label="起始时间">
          <div class="block">
            <span class="demonstration"></span>
            <el-date-picker
              size="small"
              v-model="formInline.create_time"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            ></el-date-picker>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
          <el-table-column prop="order_no" label="单号"></el-table-column>
          <el-table-column prop="user_id" label="报单用户">
            <template slot-scope="scope">
              <div v-if="scope.row.user">{{scope.row.user.nickName}}【{{scope.row.user.user_id}}】</div>
            </template>
          </el-table-column>
          <el-table-column prop="pay_price" label="报单金额"></el-table-column>
          <el-table-column prop="image_url" label="报单凭证">
            <template slot-scope="scope">
               <el-image 
                style="width: 100px; height: 100px"
                :src="scope.row.image_url" 
                :preview-src-list="[scope.row.image_url]">
              </el-image>
            </template>
           
          </el-table-column>
          <el-table-column prop="status" label="状态">
            <template slot-scope="scope">
               <span class="green" v-if="scope.row.status==1">已审核</span>
               <span v-else>待审核</span>
            </template>
           
          </el-table-column>
          <el-table-column prop="create_time" label="创建时间"></el-table-column>
          <el-table-column fixed="right" label="操作" width="50">
            <template slot-scope="scope">
              <div>
                <el-button v-if="scope.row.status == 0" @click="editClick(scope.row)" type="text" size="small">
                  审核
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage"
          :page-size="pageSize" layout="total, prev, pager, next, jumper"
          :total="totalDataNumber">
        </el-pagination>
      </div>
    </div>
    <Edit v-if="open_edit" :open_edit="open_edit" :form="dataModal" @closeDialog="closeDialogFunc($event)"></Edit>
  </div>
</template>

<script>
  import Notetaking from '@/api/notetaking.js';
  import Edit from './dialog/Edit.vue';
  export default {
    components: {
      /*编辑组件*/
      Edit
    },
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*所属门店数据*/
        storeList: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*横向表单数据模型*/
        formInline: {
          agent_user_id:'',
          order_no:"",
          pay_status:'20',
          store_id: '',
          search: '',
          machine_id:'',
          create_time:''
        },
        total_price:0,
        /*是否打开添加弹窗*/
        open_add: false,
        /*是否打开编辑弹窗*/
        open_edit: false,
        /*当前编辑的对象*/
        dataModal: {},
        totalPrice:0,
      };
    },
    created() {

      /*获取列表*/
      this.getTableList();

    },
    methods: {

      /*选择第几页*/
      handleCurrentChange(val) {
        let self = this;
        self.curPage = val;
        self.loading = true;
        self.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },

      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = self.formInline;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
         self.loading = true;
        Notetaking.orderList(Params, true)
          .then(data => {
            self.loading = false;
            self.tableData = data.data.list.data;
            self.totalDataNumber = data.data.list.total
            self.storeList = data.data.store_list
          })
          .catch(error => {
            self.loading = false;
          });
      },

      /*搜索查询*/
      onSubmit() {
        this.curPage = 1;
        this.getTableList();
        this.getTotalPrice();
      },
      /*打开弹出层编辑*/
    editClick(item) {
      this.dataModal = item;
      this.open_edit = true;
    },

      /*关闭弹窗*/
      closeDialogFunc(e) {
        this.open_edit = e.openDialog;
          if (e.type == 'success') {
            this.getTableList();
          }
      }

    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/notetaking/order/index.vue